/**
 * File Name Constants - By John Bellew - Infinia.ie - last updated 10/07/2025
 * 
 * A comprehensive file name constants registry with advanced organization:
 * - Centralized JSON file name definitions
 * - Organized by functional category for easy maintenance
 * - Consistent naming convention across the portal
 * - Type-safe file name references
 * - Easy refactoring and file name updates
 * - Documentation for each file's purpose
 * - Alphabetical organization within categories
 * 
 * File Categories:
 * - Benefits & Member Content: Member benefits and repository items
 * - News & Media: News articles, featured content, and media center
 * - Working Groups: Structure, members, meetings, and documentation
 * - Organizational: Council members, executives, and strategy
 * - Policy & Regulatory: Consultations, updates, and external sources
 * - Technical: Daire AI content, capabilities, and innovation data
 * - Events & Timeline: Historical events and ticker information
 * - ETF & Financial: ETF book data and financial information
 * 
 * Usage:
 * import { FILE_NAMES } from './constants';
 * const result = await apiHelper.fetchJSONFileByNameAndContent(FILE_NAMES.BENEFITS);
 * 
 * Benefits:
 * - Centralized file name management
 * - Type safety and auto-completion
 * - Easy file name updates and refactoring
 * - Consistent naming across components
 * - Documentation of file purposes
 * - Reduced typos and errors
 * - Improved maintainability
 * 
 * @constant {Object} FILE_NAMES - Object containing all JSON file name constants
 * @returns {Object} Organized file name constants for portal data files
 */
export const FILE_NAMES = {
    FEATURED_NEWS: 'featured.json',
    MONTHLY_NEWS: 'monthlyNews.json',
    FEATURED_AND_SUBMITTED_ARTICLES: 'featured_and_submitted_articles.json',
    BENEFITS: 'benefits.json',
    REPOSITORY_ITEMS: 'repository_items.json',
    CBI_QUARTERLY_UPDATES: 'cbi_quarterly_updates.json',
    CONSULTATIONS: 'Consultations.json',
    KEY_POLICY_MESSAGES: 'key_policy_messages.json',
    TICKER: 'ticker.json',
    TIMELINE: 'timeline.json',
    TRIAGE: 'Triage.json',
    EXTERNAL_INFO_SOURCES_CATEGORIES: 'external_info_sources_categories.json',
    EXTERNAL_INFO_SOURCES: 'external_info_sources.json',
    PAGES: 'pages.json',
    PAGECONTENT: 'page_content.json',
    WG_PARTICIPATION: 'wg_participation.json',
    CAPABILITIES: 'capabilities.json',
    INNOVATION: 'innovation.json',
    MEMBERS_COUNCIL: 'council_members.json',
    COUNCIL_STRATEGY: 'council_strategy.json',
    MONTHLY_ROUNDUP: 'monthly_roundup.json',
    IRISH_FUNDS_EXECUTIVES: 'irishfunds_executives.json',
    WG_STRUCTURE: 'wg_structure.json',
    WG_TYPES: 'wg_types.json',
    WG_PERIODIC_UPDATES: 'wg_periodic_updates.json',
    WG_MEMBER_DETAILS: 'wg_member_details.json',
    WG_TOR: 'wg_tor.json',
    WG_MINUTES: 'wg_minutes.json',
    WG_REFERENCE_DOCS: 'wg_reference_docs.json',
    MEDIA_CENTRE: 'media_centre.json',
    DAIRE_OPTIONS: 'daire-options.json',
    DAIRE_SUGGESTIONS: 'daire-suggestions.json',
    COUNCIL_REFERENCE_DOCS: 'cc_reference_docs.json',
    EVENTS: 'events.json',
    ETF_BOOK_GRAPH: 'etf-dynamic-data.json',
    ETF_BOOK: 'etf-static-data.json',
    NEWS: 'news.json',
    SETTINGS: 'settings.json'
};


